import RUGRequest from "react-upload-gallery/dist/Request";
import { shrinkImageForUpload } from "../../../core/utils/shrinkImage.js";

// RUG starts every dropped file's upload at once. With a bulk drop (15-20
// photos) that meant every shrink and every upload shared the CPU and the
// connection: all cards sat near 0% and none finished until all did. Run at
// most MAX_PARALLEL at a time so cards complete one after another.
const MAX_PARALLEL = 3;
const SLOT_TIMEOUT_MS = 120000;
let active = 0;
const waiting = [];
const pump = () => {
  while (active < MAX_PARALLEL && waiting.length) {
    const job = waiting.shift();
    active++;
    job().finally(() => {
      active--;
      pump();
    });
  }
};

// RUG's default XHR upload, but queued (above) and with oversized photos
// shrunk under the API's 5 MB cap first. RUG needs `{ abort }` back
// synchronously, so the real request starts later and abort is forwarded.
export const shrinkingRequest = (opts) => {
  let inner = null;
  let aborted = false;
  waiting.push(
    () =>
      new Promise((done) => {
        if (aborted) return done();
        // A request that never answers must not hold its slot and stall the
        // whole queue: free the slot after SLOT_TIMEOUT_MS (the request
        // itself keeps going and still reports to RUG when it ends).
        setTimeout(done, SLOT_TIMEOUT_MS);
        shrinkImageForUpload(opts.file).then((file) => {
          if (aborted) return done();
          inner = RUGRequest({
            ...opts,
            file,
            onSuccess: (...args) => {
              done();
              opts.onSuccess(...args);
            },
            onError: (...args) => {
              done();
              // A card removed mid-upload aborts its XHR; that's not a failure.
              if (!aborted) opts.onError(...args);
            },
          });
        });
      })
  );
  pump();
  return {
    abort: () => {
      aborted = true;
      inner?.abort();
    },
  };
};
